import { useState } from 'react'

import { fromDTO } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/hooks/useGetWorkspaceBidder/api/mapper'
import { GET_WORKSPACE_BIDDER } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/hooks/useGetWorkspaceBidder/api/query'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { Data, Variables } from './api/types'
import { Props, UseGetWorkspaceBidder, WorkspaceBidderSlice } from './types'

export const useGetWorkspaceBidder = ({ id }: Props): UseGetWorkspaceBidder => {
  const [workspaceBidder, setWorkspaceBidder] = useState<WorkspaceBidderSlice>()

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { node: workspaceBidder } = data

      if (workspaceBidder) {
        setWorkspaceBidder(fromDTO(workspaceBidder))
      }
    },
    options: { enabled: !!id },
    query: GET_WORKSPACE_BIDDER,
    variables: { id: id! },
  })

  return {
    loading: isLoading,
    workspaceBidder,
  }
}
